const makeCircuitBreakerHash = (method, requestedServerName, pathname) => `${method}:${requestedServerName}:${pathname}`;
const defaultAssertStatusCode = (statusCode) => statusCode >= 200 && statusCode < 400;
const defaultModelAssertStatusCode = (assertStatusCodes) => (statusCode) => assertStatusCodes.includes(statusCode);
export { defaultAssertStatusCode, defaultModelAssertStatusCode, makeCircuitBreakerHash };
//# sourceMappingURL=defaultSettings.js.map